import * as actionTypes from "../action-types";

export const getPayoutSettings = payload => ({ type: actionTypes.GET_PAYOUT_SETTINGS, payload });
export const setPayoutSettings = payload => ({ type: actionTypes.SET_PAYOUT_SETTINGS, payload });
export const toggleAutoPayout = payload => ({ type: actionTypes.TOGGLE_AUTO_PAYOUT, payload });
export const getPendingPayouts = payload => ({ type: actionTypes.GET_PENDING_PAYOUTS, payload });
export const setPendingPayouts = payload => ({ type: actionTypes.SET_PENDING_PAYOUTS, payload });
export const processPayout = payload => ({ type: actionTypes.PROCESS_PAYOUT, payload });
export const processAllPayouts = payload => ({ type: actionTypes.PROCESS_ALL_PAYOUTS, payload });
export const getPayoutHistory = payload => ({ type: actionTypes.GET_PAYOUT_HISTORY, payload });
export const setPayoutHistory = payload => ({ type: actionTypes.SET_PAYOUT_HISTORY, payload });
